import React, { useState, useEffect } from "react";
import "../Home/Home.css";
import { FaEnvelope } from "react-icons/fa";
import banner1 from "../../assets/images/banner1.jpg";
import banner2 from "../../assets/images/banner2.jpg";
import banner3 from "../../assets/images/banner3.jpg";
import appstoreapple from "../../assets/images/app-store-apple.png";
import appstoreplay from "../../assets/images/app-store-play.png";
import Footer from "../Footer/Footer";
import { subscribeTonewsletter } from "../api/api";
import Swal from "sweetalert2";
import { Navigate, useNavigate } from "react-router-dom";
import { miscHome } from "../api/api";
import { FaArrowRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
const newsletterSchema = Yup.object({
  email: Yup.string()
    .email("Please enter a valid email")
    .required("Email is required"),
});

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [email, setemail] = useState("");
  const [bulletIndex, setBulletIndex] = useState(0);
  const [isDesignMode, setIsDesignMode] = useState(true);
  const [storedata, setstoredata] = useState({});
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slideInterval, setSlideInterval] = useState(null);
  const slides = [
    {
      id: 1,
      title: "Serious About Love,",
      highlighted: "Commitment & Vow? So Are We.",
      image: banner3,
      btnLink: "/login",
      btnText: "Find A Match",
    },
    {
      id: 2,
      title: "Love That Starts With Clarity.",
      highlighted: "Grows With Purpose.",
      image: banner2,
      btnLink: "/login",
      btnText: "Find A Match",
    },
    {
      id: 3,
      title: "Matchmaking Is Not An",
      highlighted: "Ancient Word!",
      image: banner1,
      btnLink: "/login",
      btnText: "Find A Match",
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 3000);
    setSlideInterval(interval);

    return () => clearInterval(interval);
  }, []);

  const handleMouseEnter = () => {
    clearInterval(slideInterval);
  };

  const handleMouseLeave = () => {
    const interval = setInterval(nextSlide, 3000);
    setSlideInterval(interval);
  };

  useEffect(() => {
    const getdata = async () => {
      const miscHomedata = await miscHome();
      console.log("miscHomeData", JSON.stringify(miscHomedata));
      setstoredata(miscHomedata);
    };
    getdata();
  }, []);

  const navigate = useNavigate();
  useEffect(() => {
    let interval;
    let timeout;

    if (currentIndex === 2) {
      interval = setInterval(() => {
        setBulletIndex((prev) => (prev + 1) % 3);
      }, 5000);
      timeout = setTimeout(() => {
        setCurrentIndex(0);
      }, 8000);
    } else {
      timeout = setTimeout(() => {
        if (storedata?.banner?.length) {
          setCurrentIndex(
            (prevIndex) => (prevIndex + 1) % storedata.banner.length
          );
        }
      }, 6000);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
      setBulletIndex(0);
    };
  }, [currentIndex, storedata?.banner?.length]);

  const goToImage = (index) => {
    setCurrentIndex(index);
  };
  useEffect(() => {
    console.log("Current index is:", currentIndex);
  }, [currentIndex]);
  return (
    <>
      <div
        className="slider-container"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="slider">
          {storedata?.banner?.map((slide, index) => (
            <div
              key={slide.id}
              className={`slide ${index === currentSlide ? "active" : ""}`}
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(https://backend.connecttovow.com/uploads/banners/${slide?.image})`,
              }}
            >
              <div className="containerall">
                <div className="slide-content">
                  {/* <h2>
                    {slide.title.split(slide.highlighted)[0]}
                    <span> {slide.subtitle}</span>
                  </h2> */}
                  <h2
                    style={{
                      fontSize: `${slide?.title_size}`,
                      marginBottom: 10,
                    }}
                  >
                    {slide.title}
                  </h2>
                  <h2
                    style={{
                      fontSize: `${slide?.subtitle_size}`,
                    }}
                  >
                    <span> {slide.subtitle}</span>
                  </h2>
                  <a href={slide.btnLink} className="slider-btn">
                    Find A Match
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="slider-arrow left" onClick={prevSlide}>
          <FaChevronLeft />
        </div>
        <div className="slider-arrow right" onClick={nextSlide}>
          <FaChevronRight />
        </div>
      </div>
      {/* <div className="about">
        <div className="containerall">
          <div className="aboutus">
            <div className="about-img">
              <img
                src={`https://backend.connecttovow.com/uploads/homepage/${storedata?.misc?.description_1_image}`}
                alt="Dynamic"
              />
            </div>
            <div className="about-text">
              <h2>
                {storedata?.misc?.description_1_title}
                <br />
                {storedata?.misc?.description_1_subtitle}
              </h2>

              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  fontFamily: '"Raleway", sans-serif',
                  fontWeight: 500,
                  fontSize: "16px",
                  lineHeight: "27px",
                }}
              >
                {storedata?.misc?.description_1_content
                  ?.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
                  ?.replace(/<br\s*\/?>/gi, "\n")
                  ?.replace(/<[^>]+>/g, "")
                  ?.replace(/&nbsp;/g, " ")
                  ?.replace(/\u200B/g, "")
                  ?.replace(/\\n/g, "\n")
                  ?.trim()}
              </pre>

              <button className="main-btn" onClick={() => navigate("/about")}>
                Read More
              </button>
            </div>
          </div>
        </div>
      </div> */}

      <div className="about">
        <div className="containerall">
          <div className="aboutus">
            <h1>
              Where Purposeful Connections Become Lifelong Commitments <br />
              At ConnectToVow, we know marriage isn't a milestone it’s a
              mission. That’s why we do matchmaking differently.
            </h1>
          </div>
        </div>
      </div>
      <div className="searchlove">
        <div className="containerall">
          <div className="home-thirdContainer">
            {storedata?.searchforlovedescWeb?.map((card, index) => (
              <div className="home-card" key={index}>
                <div className="home-profilePic">
                  <img
                    src={`https://backend.connecttovow.com/uploads/searchforlove/${card?.loveimage}`}
                    alt="profile"
                  />
                </div>
                <div className="home-descriptiondiv">
                  <h4 className="home-title">{card.title}</h4>
                  <p className="home-description-first">{card.description}</p>
                  <div className="bottom-circle-arrow">
                    <div className="home-bottomCircle">
                      <FaChevronRight size="md" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        className="home-sixdiv"
        style={{
          backgroundImage: `url(https://backend.connecttovow.com/uploads/homepage/${storedata?.misc?.description_2_image})`,
        }}
      >
        <div className="containerall">
          <div className="home-sixdivoverlay">
            <h2 className="home-hero-text">
              {storedata?.misc?.description_2_title}
              <br />
              {storedata?.misc?.description_2_subtitle}
            </h2>
            <h4 className="home-hero-text2">
              {storedata?.misc?.description_2_content
                ?.replace(/<br\s*\/?>/gi, "\n")
                ?.replace(/<[^>]+>/g, "")}
            </h4>

            <button className="main-btn" onClick={() => navigate("/login")}>
              Create Your Profile
            </button>
          </div>
        </div>
      </div>
      <div className="service-firstContainer-div">
        <div className="containerall">
          <div className="services-title-div">
            <h2 className="services-title">Why Choose Us</h2>
          </div>
          <div className="services-grid">
            {storedata?.whychooseus?.map((service, index) => (
              <div key={index} className="service-item">
                <div className="service-icon">
                  <FaArrowRight size="md" />
                </div>
                <h3 className="service-title">{service?.title}</h3>
                <div className="service-description-div">
                  <p className="service-description">{service?.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        className="home-sixdiv"
        style={{
          backgroundImage: `url(https://backend.connecttovow.com/uploads/homepage/${storedata?.misc?.download_app_image})`,
        }}
      >
        <div className="containerall">
          <div className="home-sixdivoverlay">
            <p className="home-app-contant">
              {storedata?.misc?.download_app_heading}
            </p>
            <h2 className="home-app-text">
              {storedata?.misc?.download_app_title}
            </h2>
            <h4 className="home-app-text2">
              {storedata?.misc?.download_app_description}
            </h4>
            <div className="app-store-main">
              <a
                href={storedata?.misc?.app_link_appstore}
                target="_blank"
                rel="noopener noreferrer"
                className="app-store-sec"
              >
                <img src={appstoreapple} alt="App Store Apple" />
              </a>
              <a
                href={storedata?.misc?.app_link_playstore}
                target="_blank"
                rel="noopener noreferrer"
                className="app-store-sec"
              >
                <img src={appstoreplay} alt="App Store Play" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="home-sevendiv">
        <div className="containerall">
          <div className="home-newsletter-container">
            {/* <div className="home-newsletter-content">
              <div className="home-newsletter-title-div">
                <FaEnvelope style={{ fontSize: "80px", color: "#fff" }} />
                <h2 className="home-newsletter-title">
                  {storedata?.misc?.homepage_footer_title}
                </h2>
              </div>
              <p className="home-newsletter-description">
                {storedata?.misc?.homepage_footer_description_1}
                <br />
                {storedata?.misc?.homepage_footer_description_2}
              </p>
              <button className="main-btn" onClick={() => navigate("/login")}>
                Create Your Profile
              </button>
            </div> */}
            <div className="home-newsletter-content">
              <p className="home-newsletter-title-sub">
                {storedata?.misc?.homepage_footer_description_1}
                <br />
                {storedata?.misc?.homepage_footer_description_2}
              </p>
              <button
                className="main-btn"
                onClick={() => navigate("/login")}
                style={{ marginTop: "8%" }}
              >
                Create Your Profile
              </button>
            </div>

            <div className="home-newsletter-form">
              <div className="home-newsletter-title-div">
                <FaEnvelope style={{ fontSize: "50px", color: "#fff" }} />
                <h2 className="home-newsletter-title-sub">
                  {storedata?.misc?.homepage_footer_title}
                </h2>
              </div>
              <div className="home-newsletter-title-div">
                <h2 className="home-newsletter-title">
                  {storedata?.misc?.homepage_footer_newsletter_text}
                </h2>
              </div>

              <Formik
                initialValues={{ email: "" }}
                validationSchema={newsletterSchema}
                onSubmit={async (values, { resetForm, setSubmitting }) => {
                  try {
                    const response = await subscribeTonewsletter(values);
                    if (response?.success) {
                      Swal.fire({
                        icon: "success",
                        title: "Subscribed!",
                        text: response?.message,
                      });
                      resetForm();
                    } else {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: response?.message,
                      });
                    }
                  } catch (err) {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text:
                        err?.response?.data?.message ||
                        err.message ||
                        "Something went wrong!",
                    });
                  } finally {
                    setSubmitting(false);
                  }
                }}
                // validate={(values) => {
                //   try {
                //     newsletterSchema.validateSync(values, {
                //       abortEarly: false,
                //     });
                //   } catch (validationErrors) {
                //     const firstError = validationErrors.errors[0];
                //     Swal.fire({
                //       icon: "error",
                //       title: "Validation Error",
                //       text: firstError,
                //     });
                //     return { email: firstError };
                //   }
                // }}
              >
                {({ isSubmitting }) => (
                  <Form className="inputbtn">
                    <Field
                      name="email"
                      type="email"
                      placeholder="YOUR EMAIL ADDRESS"
                      className="home-email-input"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="form-error"
                    />
                    <button
                      type="submit"
                      className="main-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Subscribe"}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
};
export default Home;
